import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBookmark"><Path d="M6.75 2C5.23122 2 4 3.23122 4 4.75V20.2515C4 21.6527 5.56475 22.4857 6.72719 21.7032L11.302 18.6239C11.724 18.3399 12.276 18.3399 12.698 18.6239L17.2728 21.7032C18.4353 22.4857 20 21.6527 20 20.2515V4.75C20 3.23122 18.7688 2 17.25 2H6.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmark;
